import scaImage from "../../../images/sca.png";
import crgImage from "../../../images/crg.png";
import wcrImage from "../../../images/wcr.png";
import hcaImage from "../../../images/hca.png";
import inSVG from "../../../images/icons/in.svg";
import igSVG from "../../../images/icons/ig.svg";
import fbSVG from "../../../images/icons/fb.svg";
import ytSVG from "../../../images/icons/yt.svg";

export const footerLogos = [
    {
        link: "https://sca.coffee/",
        name: "Specialty Coffee Association",
        iconClass: "sca",
        src: scaImage
    },{
        link: "https://www.crgretreat.coffee/",
        name: "Coffee Roasters Guild",
        iconClass: "crg",
        src: crgImage
    },{
        link: "https://hawaiicoffeeassoc.org/",
        name: "Hawaii Coffee Association",
        iconClass: "hca",
        src: hcaImage
    }
]

export const footerSocials = [
    {
        link: "https://www.linkedin.com/company/savor-brands-inc",
        name: "Linkedin",
        svg: inSVG
    },
    {
        link: "https://www.instagram.com/savorbrands/",
        name: "Instagram",
        svg: igSVG
    },
    {
        link: "https://www.facebook.com/SavorBrandsInc/",
        name: "Facebook",
        svg: fbSVG
    },
    {
        link: "https://www.youtube.com/channel/UCBLRs2gzAnUE5bg3P_Y2jjA",
        name: "Youtube",
        svg: ytSVG
    }
]